var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box-content" },
    [
      _c("heading", {
        attrs: { border: "" },
        scopedSlots: _vm._u([
          {
            key: "upper",
            fn: function () {
              return [
                _c("span", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _vm.running
                  ? _c("spinner-bars")
                  : _c("span", [
                      _vm._v(_vm._s(_vm.time.format("DD/MM/YYYY HH:mm:ss"))),
                    ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "b-input-group",
            {
              attrs: { size: "sm", prepend: "for" },
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: { click: _vm.runImport },
                        },
                        [_vm._v("Import")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.theatres, size: "sm" },
                on: { change: _vm.onTheatreChange },
                model: {
                  value: _vm.theatre,
                  callback: function ($$v) {
                    _vm.theatre = $$v
                  },
                  expression: "theatre",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-form-text", [
        _vm._v("Leave the dropdown blank to run the import for all theatres."),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }